import type { ComponentType } from "react";

import { OverviewCard } from "@eisox/design-system";
import type { IconProps } from "@eisox/icons";
import type { colors } from "@eisox/tokens";

import { Help } from "~/components/help";

interface Kpi {
  Icon: ComponentType<IconProps>;
  value: string;
  label: string;
  help?: string;
  color?: keyof typeof colors.primary;
}

interface KpiGridProps {
  kpis: Kpi[];
}

const KpiGrid: React.FC<KpiGridProps> = ({ kpis }) => (
  <div className="@container">
    <div className="gap-2.5 md:gap-5 @4xl:auto-cols-fr @4xl:grid-flow-col @max-4xl:*:last:odd:col-span-2 grid grid-cols-2 *:w-full">
      {kpis.map(({ Icon, value, label, help, color }) => (
        <OverviewCard
          key={label}
          variants="info"
          iconBackgroundColor={color}
          color={color && "white"}
          icon={<Icon />}
          title={value}
          subtitle={
            help ? (
              <span className="gap-x-1.5 flex flex-wrap items-center">
                {label}
                <Help size={16} backgroundColor="white" className="shrink-0">
                  {help}
                </Help>
              </span>
            ) : (
              label
            )
          }
        />
      ))}
    </div>
  </div>
);

KpiGrid.displayName = "KpiGrid";

export { KpiGrid };
export type { Kpi };
